export default __webpack_public_path__ + "static/media/Invoice.5dacd142.pdf";